<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop no-close-on-esc hide-header-close id="modal-lg" header-class="my-class" size="md"
      title="Create hospital" ref="modal-edit">
      <template #modal-header="{ close }" class="bg-dark">
        <p class="w-100 pt-3 text-center text-white h-100" size="sm" disabled variant="outline-danger"> アカウント登録 </p>
      </template>
      <div class="row">
        <div class="col-12">
          <b-form-group class="mb-3" label-for="phone">
            <label class="text-label">
              施設名
              <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <multiselect label="name" track-by="name" :taggable="true" :multiple="false" :show-labels="false" tagPlaceholder
              v-model="facility" :options="facilities" :allow-empty="false" placeholder="施設を選択してください。"></multiselect>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group class="mb-3">
            <label class="text-label">
              担当者名 <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <b-form-input ref="input" placeholder="担当者名を入力してください。" type="text" :formatter="formatStringName"
              v-model.trim="dataInsert.information.fullname"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-12 mt-2">
          <b-form-group class="mb-3" label-for="username">
            <label class="text-label">
              携帯番号
              <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <b-form-input ref="input" placeholder="携帯番号を入力してください。" maxlength="11" v-model.trim="dataInsert.mobile"
              @keydown="handleKeyDown"></b-form-input>
            <div class="text-danger mt-1" v-if="!this.passPhoneNumber() && dataInsert.mobile != ''">
              <div>携帯番号について</div>
              <div>・10-11桁の数字</div>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group>
            <label class="text-label">
              パスワード
              <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2 password">必須</span>
            </label>
            <input class="form-control" :class="!isShowPassword ? 'hide' : ''" autocomplete="off" ref="input"
              placeholder="パスワードを入力してください。" id="input-2" v-model="dataInsert.password" maxlength="128" type="text" />
            <div class="eye" @click="showHide()">
              <img src="@/assets/images/show.svg" v-if="isShowPassword" />
              <img src="@/assets/images/hide.svg" v-if="!isShowPassword" />
            </div>
          </b-form-group>
        </div>
        <div class="text-danger mt-1" v-if="!this.passPassword() && dataInsert.password != ''">
          <div>パスワードの設定について</div>
          <div>・8-128文字の英数字を使用してください 例)test1234</div>
          <div>・特殊記号は含まない</div>
        </div>
        <div class="mb-3"></div>
        <div class="col-12">
          <b-form-group>
            <label class="text-label">
              パスワード（確認用）
              <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2 password">必須</span>
            </label>
            <input class="form-control" :class="!isShowConfirmPassword ? 'hide' : ''" autocomplete="off" ref="input"
              placeholder="パスワードを入力してください。" id="input-2" v-model="dataInsert.confirmPassword" maxlength="128" type="text" />
            <div class="eye" @click="showHideConfirmPassword()">
              <img src="@/assets/images/show.svg" v-if="isShowConfirmPassword" />
              <img src="@/assets/images/hide.svg" v-if="!isShowConfirmPassword" />
            </div>
          </b-form-group>
        </div>
        <div class="text-danger mt-1" v-if="passConfirmPassword()">
          <div>パスワードが一致しません。もう一度お試しください。</div>
        </div>
        <div class="mb-3"></div>
        <div class="col-12 mt-2">
          <b-form-group class="mb-3" label-for="username">
            <label class="text-label">メール </label>
            <b-form-input ref="input" placeholder="メールを入力してください。" v-model.trim="dataInsert.email"></b-form-input>
            <div class="text-danger mt-1" v-if="!this.passEmail() && dataInsert.email != ''">
              <div>有効なメールアドレスではありません。</div>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group class="mb-3">
            <label class="text-label">施設区分</label>
            <b-form-input ref="input" placeholder="施設区分を入力してください。" type="text"
              v-model.trim="dataInsert.information.category_name" disabled></b-form-input>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group class="mb-3">
            <label class="text-label">施設コード</label>
            <b-form-input ref="input" placeholder=" 施設コードを入力してください。。" type="text"
              v-model.trim="dataInsert.facility.code" disabled></b-form-input>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group class="mb-3" label-for="phone">
            <label class="text-label">
              部門
              <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <div v-if="facility">
              <multiselect label="name" track-by="name" :taggable="true" :multiple="false" :show-labels="false" tagPlaceholder
                v-model="department" :options="departments" :allow-empty="false" placeholder="部門を選択してください。"></multiselect>
            </div>
            <input class="form-control" v-if="!facility" placeholder="部門を選択してください。" type="text" disabled>
          </b-form-group>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 row p-0">
          <div class="col-6 p-0" style="padding-right: 2px !important">
            <b-button class="w-100" type="button" @click="closeModal()" variant="outline-danger"> キャンセル </b-button>
          </div>
          <div class="col-6 p-0">
            <b-button type="button" :disabled="disabled()" @click="submit" class="w-100 btn-lyg"
              style="padding-left: 2px !important" variant="primary"> 保存 </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  facilityMethods,
  facilityComputed,
  userMethods,
} from "@/state/helpers";
import Multiselect from "vue-multiselect";
import { mixin } from "@/helpers/Vue-Mixin";
import api from "@/api/";

export default {
  props: ["isShow"],
  data() {
    return {
      dataInsert: {
        patient_id: "",
        password: "",
        confirmPassword: "",
        mobile:"",
        email:"",
        facility_id: "",
        department_id: "",
        information: {
          fullname: "",
          creator_name: "",
          category_name: "",
        },
        role: "hospital",
        facility: {
          id: "",
          name: "",
          code: "",
        },
      },
      gender: ["Male", "Female", "Other"],
      show: false,
      departmentOther: "",
      showOther: false,

      observerCategory: null,
      observerDepartment: null,
      optionCategories: [],
      optionDepartments: [],
      loadMoreCategory: true,
      loadMoreDepartment: true,

      facilities: [],
      facility: null,
      departments: [],
      department: null,

      errorMsg: "",
      isShowPassword: false,
      isShowConfirmPassword: false,
    };
  },

  mixins: [mixin],

  components: {
    Multiselect,
  },

  watch: {
    isShow: {
      handler(value) {
        this.show = JSON.parse(value);
      },
    },
    facility: {
      handler(value) {
        if(value) {
          this.departments = value.departments;
          this.dataInsert.facility = {
            id: value.id,
            name: value.name,
            code: value.code,
          };
          this.dataInsert.facility_id = value.id;
          this.dataInsert.information.category_name = value.categories[0].name;
          this.department = null;
        }
      },
      deep: true,
    },
    department: {
      handler(value) {
        this.dataInsert.department_id = value ? value.id : null;
      },
      deep: true,
    },
  },

  created() {
    this.show = JSON.parse(this.isShow);
    this.listFacility();
  },

  computed: {
    ...facilityComputed,
  },

  methods: {
    ...facilityMethods,
    ...userMethods,

    listFacility(){
      api.getListNameFacility().then((e) =>{
        if (e.status === 200) {
          this.facilities = e.data;
        }
      });
    },

    formatStringName(e) {
      const length = this.maxLength(e);
      if (length > 20) {
        return this.dataInsert.information.fullname;
      }
      return e;
    },
    handleKeyDown(event) {
      const key = event.key;
      if (!/^\d$|^Backspace$|^ArrowLeft$|^ArrowRight$|^ArrowUp$|^ArrowDown$|^Delete$/.test(key)) {
        event.preventDefault();
      }
    },

    disabled() {
      return !(
        this.passPhoneNumber() &&
        this.passPassword() &&
        !this.passConfirmPassword() &&
        this.passName() &&
        this.passFacility() &&
        this.passDepartment()
      );
    },

    closeModal() {
      this.$emit("closeModal");
      this.dataInsert = {
        patient_id: "",
        password: "",
        confirmPassword: "",
        mobile: "",
        email: "",
        facility_id: "",
        department_id: "",
        information: {
          fullname: "",
          creator_name: "",
          category_name: "",
        },
        role: "hospital",
        facility: {
          id: "",
          name: "",
          code: "",
        },
      };
      this.facility = null;
      this.department = null;
    },


    passPhoneNumber(){
       return (
        /^\d{10,11}$/.test(this.dataInsert.mobile)
      );
    },

    passEmail(){
      return (
        /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{1,7}$/.test(this.dataInsert.email)
      );
    },

    passPassword() {
      return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,128}$/.test(this.dataInsert.password);
    },

    passConfirmPassword() {
      return (this.dataInsert.password !== this.dataInsert.confirmPassword) && this.dataInsert.confirmPassword !== ''
    },

    passId() {
      return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]$/.test();
    },

    passName() {
      return (
        this.dataInsert.information.fullname !== "" &&
        this.maxLength(this.dataInsert.information.fullname) <= 20
      );
    },

    passFacility() {
      return this.dataInsert.facility_id > 0;
    },

    passDepartment() {
      return this.dataInsert.department_id > 0;
    },

    maxLength(text) {
      let index = 0;
      const { length } = text;
      let char = "";
      let length_actual = 0;
      for (; index < length; index++) {
        char = text.charCodeAt(index);
        if (char >= 0x0000 && char <= 0x0019) {
          length_actual += 0;
        } else if (char >= 0x0020 && char <= 0x1fff) {
          length_actual += 1;
        } else if (char >= 0x2000 && char <= 0xff60) {
          length_actual += 2;
        } else if (char >= 0xff61 && char <= 0xff9f) {
          length_actual += 1;
        } else if (char >= 0xffa0) {
          length_actual += 2;
        }
      }
      return length_actual;
    },

    async submit() {
      try {
        const response = await this.post(this.dataInsert);
        if (response.status === 200) {
          this.getACountUser(this.dataInsert.role)
          this.$emit("successInsert");
          this.closeModal();
        }
      } catch (error) {
        if(error.message == "MSG_001"){
          window.toastr.error("必須項目を入力してください。");
        } else if(error.message == "MSG_035"){
          window.toastr.error("登録されている携帯番号。");
        }else {
          window.toastr.error("何か間違っている");
        }
      }
    },

    showHide() {
      this.isShowPassword = !this.isShowPassword;
    },
    showHideConfirmPassword() {
      this.isShowConfirmPassword = !this.isShowConfirmPassword;
    },
  },
};
</script>

<style scoped>
::v-deep .my-class {
  background: #395299;
  color: white;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
  height: 70px;
  line-height: 18px;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  font-family: "Noto Sans JP";
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

::-webkit-input-placeholder {
  font-family: "Noto Sans JP";
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

.text-label {
  font-weight: 500 !important;
  color: #404040;
}

.text-label-required {
  font-weight: 500 !important;
  color: #f5f5f5;
}

.btn-lyg {
  color: #ffffff;
  background-color: #395299 !important;
  border-color: #395299 !important;
}

.bg-required-label {
  background: #ff5858 !important;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}

.loader {
  text-align: center;
  color: black;
}

.password {
  position: relative;
}

.eye {
  position: absolute;
  bottom: 5px;
  right: 20px;
  cursor: pointer;
}
.hide {
  -webkit-text-security: disc;
}
</style>
